<template>
    <div class="head-bar text-white px-12 px-24@md u-flex u-flex--vertical-align u-flex--space-between u-flex-no-shrink">
        <router-link :to="{ name: 'Home' }" class="link text-white">
            <h1 class="head-bar__title m-0">BONBON</h1>
        </router-link>

        <div v-if="isAuthenticated" class="head-bar--right u-flex u-flex--vertical-align">
            <form class="head-bar__filter-menu u-flex">
                <button
                    v-if="search"
                    class="head-bar__filter-menu__reset u-reset-button text-white mr-3"
                    type="reset"
                    @click="resetSearch"
                >
                    <small>Filter zurücksetzen</small>
                </button>
                <auto-complete
                    ref="autocomplete"
                    v-model="search"
                    placeholder="Dokument in Archiv suchen"
                    input-class="head-bar__search py-6 px-12"
                    :show-no-data="false"
                    @chooseItem="doSearch"
                />
            </form>
            <avatar-menu class="head-bar__avatar-menu" />
        </div>
    </div>
</template>

<script>
import AvatarMenu from '@/components/layout/AvatarMenu.vue'
import AutoComplete from '@/components/ui/AutoComplete.vue'

const DOCUMENTS_PAGE_NAME = 'Documents'

export default {
    name: 'HeadBar',

    components: { AutoComplete, AvatarMenu },

    data: () => ({ search: '' }),

    computed: {
        isAuthenticated () {
            return this.$store.getters.isAuthenticated
        },
    },

    watch: {
        $route (to) {
            try {
                if (to.name === DOCUMENTS_PAGE_NAME) return
                this.resetSearch()
            } catch (e) {
                // Do nothing, just output error
                console.log(e)
            }
        },
    },

    methods: {
        doSearch () {
            if (!this.search) return
            this.$router.push({ name: 'Documents', query: { searchTerm: this.search } })
        },

        resetSearch () {
            this.search = ''

            if (this.$route.query && this.$route.name === DOCUMENTS_PAGE_NAME) {
                this.$router.replace({ 'query': null })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.link {
    @include interaction {
        text-decoration: none;
    }
}

.head-bar {
    width: 100%;
    left: 0;
    position: fixed;
    background: $head-bar-background-color;
    background: linear-gradient(180deg, $head-bar-background-color 25%, $black 100%);
    height: $head-bar-height;
    z-index: $index-main-navigation;

    &--right {
        @include media-breakpoint-down(md) {
            margin-left: $spacing-unit-12;
        }
    }

    &__title {
        font-size: 1.5rem;
    }

    &__avatar-menu {
        @include media-breakpoint-down(md) {
            display: none !important;
        }
    }

    &__filter-menu {
        margin-right: $spacing-unit-12;

        @include media-breakpoint-down(md) {
            width: 100%;
            margin-right: 0;
        }

        &__reset {
            @include media-breakpoint-down(md) {
                display: none !important;
            }
        }
    }

    /deep/ &__search {
        height: 40px !important;
        border-width: 1px;
        border-radius: $default-border-radius;
        font-size: $font-size-14;
    }

    /deep/ .autocomplete {
        &__wrapper {
            width: 20vw;

            @include media-breakpoint-down(md) {
                width: 55vw;
            }
        }
    }
}
</style>
